import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';
import { mockListings } from '../../mockData';
import { FaDesktop, FaServer, FaHdd, FaCamera } from 'react-icons/fa';

// Graphics Card Recommendation Component
// eslint-disable-next-line no-unused-vars
const GraphicsCardRecommendation = ({ tier }) => {
  // GPU recommendations by tier
  const gpuTiers = {
    budget: [
      { model: 'NVIDIA RTX 3050 8GB', price: '1800-2300 HKD' },
      { model: 'NVIDIA RTX 2060 6GB', price: '1500-2000 HKD' },
      { model: 'AMD RX 6600 8GB', price: '1600-2200 HKD' },
      { model: 'AMD RX 7600 8GB', price: '2000-2500 HKD' }
    ],
    midrange: [
      { model: 'NVIDIA RTX 3060 Ti 8GB', price: '2500-3200 HKD' },
      { model: 'NVIDIA RTX 4060 8GB', price: '2800-3500 HKD' },
      { model: 'AMD RX 6700 XT 12GB', price: '2600-3300 HKD' },
      { model: 'NVIDIA RTX 4060 Ti 8GB', price: '3000-3800 HKD' }
    ],
    highend: [
      { model: 'NVIDIA RTX 3070 8GB', price: '3500-4500 HKD' },
      { model: 'NVIDIA RTX 4070 12GB', price: '5000-6000 HKD' },
      { model: 'AMD RX 7700 XT 12GB', price: '4500-5500 HKD' },
      { model: 'NVIDIA RTX 3080 10GB', price: '4500-5500 HKD' },
      { model: 'AMD RX 6800 XT 16GB', price: '4000-5000 HKD' }
    ],
    premium: [
      { model: 'NVIDIA RTX 4080 16GB', price: '8000-9500 HKD' },
      { model: 'NVIDIA RTX 3090 24GB', price: '7000-8500 HKD' },
      { model: 'AMD RX 7900 XTX 24GB', price: '7500-9000 HKD' },
      { model: 'NVIDIA RTX 4090 24GB', price: '13000-15000 HKD' },
      { model: 'AMD Radeon Pro W7900 32GB', price: '13000-15000 HKD' }
    ]
  };

  const recommendedGpus = gpuTiers[tier] || gpuTiers.midrange;

  return (
    <div className="gpu-recommendation-container">
      <h4>Recommended Graphics Cards:</h4>
      <div className="gpu-recommendation-list">
        {recommendedGpus.map((gpu, index) => (
          <div key={index} className="gpu-recommendation-item">
            <span className="gpu-model">{gpu.model}</span>
            <span className="gpu-price">{gpu.price}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// Featured Product Recommendation Component
// eslint-disable-next-line no-unused-vars
const FeaturedProductRecommendation = ({ productKeyword }) => {
  // Find relevant listing from mock data
  const featuredListing = mockListings.find(listing => 
    listing.title.includes(productKeyword) || listing.description.includes(productKeyword)
  );

  if (!featuredListing) return null;

  return (
    <div className="featured-product-container">
      <h4>Available Now on SwapWise:</h4>
      <Link to={`/listing/${featuredListing.id}`} className="featured-product-card">
        <div className="featured-product-image">
          <img src={featuredListing.imageUrl} alt={featuredListing.title} />
        </div>
        <div className="featured-product-info">
          <h3 className="featured-product-title">{featuredListing.title}</h3>
          <div className="featured-product-price">HK${featuredListing.price}</div>
          <div className="featured-product-condition">{featuredListing.condition}</div>
          <div className="featured-product-seller">Seller: {featuredListing.sellerUsername}</div>
          <button className="view-listing-button">View Listing</button>
        </div>
      </Link>
    </div>
  );
};

// PC Form Component
// eslint-disable-next-line no-unused-vars
const PCForm = ({ formData, handleInputChange }) => (
  <>
    <div className="form-group">
      <label htmlFor="cpu">CPU (Processor)</label>
      <input 
        type="text" 
        id="cpu" 
        name="cpu" 
        placeholder="e.g., Intel i5-10400 or AMD Ryzen 5 3600" 
        className="form-control"
        value={formData.cpu || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="gpu">GPU (Graphics Card)</label>
      <input 
        type="text" 
        id="gpu" 
        name="gpu" 
        placeholder="e.g., NVIDIA GTX 1660 or AMD RX 580" 
        className="form-control"
        value={formData.gpu || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="ram">RAM (Memory)</label>
      <input 
        type="text" 
        id="ram" 
        name="ram" 
        placeholder="e.g., 16GB DDR4 3200MHz" 
        className="form-control"
        value={formData.ram || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="storage">Storage</label>
      <input 
        type="text" 
        id="storage" 
        name="storage" 
        placeholder="e.g., 512GB SSD + 1TB HDD" 
        className="form-control"
        value={formData.storage || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="motherboard">Motherboard (Optional)</label>
      <input 
        type="text" 
        id="motherboard" 
        name="motherboard" 
        placeholder="e.g., MSI B550 or ASUS Z490" 
        className="form-control"
        value={formData.motherboard || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="pcGoal">Primary Upgrade Goal</label>
      <select 
        id="pcGoal" 
        name="pcGoal" 
        className="form-control"
        value={formData.pcGoal || 'gaming'}
        onChange={handleInputChange}
      >
        <option value="gaming">Gaming Performance</option>
        <option value="productivity">Productivity & Multitasking</option>
        <option value="design">Design & Creative Work</option>
        <option value="streaming">Content Creation & Streaming</option>
      </select>
    </div>
  </>
);

// NAS Form Component
// eslint-disable-next-line no-unused-vars
const NASForm = ({ formData, handleInputChange }) => (
  <>
    <div className="form-group">
      <label htmlFor="nasProcessor">Current Processor</label>
      <input 
        type="text" 
        id="nasProcessor" 
        name="nasProcessor" 
        placeholder="e.g., Intel Celeron J4125 or ARM v8" 
        className="form-control"
        value={formData.nasProcessor || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="nasDrives">Current Drives</label>
      <input 
        type="text" 
        id="nasDrives" 
        name="nasDrives" 
        placeholder="e.g., 2x 4TB WD Red" 
        className="form-control"
        value={formData.nasDrives || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="nasBays">Drive Bays</label>
      <input 
        type="text" 
        id="nasBays" 
        name="nasBays" 
        placeholder="e.g., 4-bay" 
        className="form-control"
        value={formData.nasBays || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="nasRam">RAM</label>
      <input 
        type="text" 
        id="nasRam" 
        name="nasRam" 
        placeholder="e.g., 4GB DDR4" 
        className="form-control"
        value={formData.nasRam || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="nasGoal">Primary Usage Goal</label>
      <select 
        id="nasGoal" 
        name="nasGoal" 
        className="form-control"
        value={formData.nasGoal || 'fileserver'}
        onChange={handleInputChange}
      >
        <option value="fileserver">File Server & Backup</option>
        <option value="mediaserver">Media Server (Plex, etc.)</option>
        <option value="virtualization">Virtualization & Docker</option>
        <option value="surveillance">Surveillance System</option>
      </select>
    </div>
  </>
);

// Server Form Component 
// eslint-disable-next-line no-unused-vars
const ServerForm = ({ formData, handleInputChange }) => (
  <>
    <div className="form-group">
      <label htmlFor="serverCpu">CPU Configuration</label>
      <input 
        type="text" 
        id="serverCpu" 
        name="serverCpu" 
        placeholder="e.g., 2x Intel Xeon E5-2680 v4" 
        className="form-control"
        value={formData.serverCpu || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="serverRam">RAM Configuration</label>
      <input 
        type="text" 
        id="serverRam" 
        name="serverRam" 
        placeholder="e.g., 64GB DDR4 ECC (4x16GB)" 
        className="form-control"
        value={formData.serverRam || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="serverStorage">Storage Configuration</label>
      <input 
        type="text" 
        id="serverStorage" 
        name="serverStorage" 
        placeholder="e.g., 4x 1TB SSD RAID 10, 8x 4TB HDD RAID 6" 
        className="form-control"
        value={formData.serverStorage || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="serverNetwork">Network Configuration</label>
      <input 
        type="text" 
        id="serverNetwork" 
        name="serverNetwork" 
        placeholder="e.g., 2x 10GbE, 2x 1GbE" 
        className="form-control"
        value={formData.serverNetwork || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="serverGoal">Primary Server Use</label>
      <select 
        id="serverGoal" 
        name="serverGoal" 
        className="form-control"
        value={formData.serverGoal || 'webhosting'}
        onChange={handleInputChange}
      >
        <option value="webhosting">Web Hosting</option>
        <option value="database">Database Server</option>
        <option value="virtualization">Virtualization Host</option>
        <option value="compute">Compute Server (ML/AI)</option>
      </select>
    </div>
  </>
);

// Camera Form Component
// eslint-disable-next-line no-unused-vars
const CameraForm = ({ formData, handleInputChange }) => (
  <>
    <div className="form-group">
      <label htmlFor="cameraType">Current Camera Type</label>
      <select 
        id="cameraType" 
        name="cameraType" 
        className="form-control"
        value={formData.cameraType || 'dslr'}
        onChange={handleInputChange}
      >
        <option value="dslr">DSLR</option>
        <option value="mirrorless">Mirrorless</option>
        <option value="compact">Compact/Point-and-Shoot</option>
        <option value="smartphone">Smartphone</option>
        <option value="action">Action Camera</option>
      </select>
    </div>
    
    <div className="form-group">
      <label htmlFor="cameraModel">Current Model (Optional)</label>
      <input 
        type="text" 
        id="cameraModel" 
        name="cameraModel" 
        placeholder="e.g., Canon EOS 80D or Sony A6400" 
        className="form-control"
        value={formData.cameraModel || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="cameraLenses">Current Lenses (Optional)</label>
      <input 
        type="text" 
        id="cameraLenses" 
        name="cameraLenses" 
        placeholder="e.g., 18-55mm kit, 50mm f/1.8" 
        className="form-control"
        value={formData.cameraLenses || ''}
        onChange={handleInputChange}
      />
    </div>
    
    <div className="form-group">
      <label htmlFor="cameraExperience">Experience Level</label>
      <select 
        id="cameraExperience" 
        name="cameraExperience" 
        className="form-control"
        value={formData.cameraExperience || 'beginner'}
        onChange={handleInputChange}
      >
        <option value="beginner">Beginner</option>
        <option value="intermediate">Intermediate</option>
        <option value="advanced">Advanced</option>
        <option value="professional">Professional</option>
      </select>
    </div>
    
    <div className="form-group">
      <label htmlFor="cameraGoal">Primary Photography Goal</label>
      <select 
        id="cameraGoal" 
        name="cameraGoal" 
        className="form-control"
        value={formData.cameraGoal || 'portrait'}
        onChange={handleInputChange}
      >
        <option value="portrait">Portrait Photography</option>
        <option value="landscape">Landscape Photography</option>
        <option value="sports">Sports & Action</option>
        <option value="wildlife">Wildlife Photography</option>
        <option value="street">Street Photography</option>
        <option value="video">Video Production</option>
      </select>
    </div>
  </>
);

function AiAdvisorPage() {
  const [deviceType, setDeviceType] = useState('pc');
  const [upgradeBudget, setUpgradeBudget] = useState('');
  const [showRecommendations, setShowRecommendations] = useState(false);
  const [recommendations, setRecommendations] = useState([]);
  
  // Device-specific form states
  const [pcFormData, setPcFormData] = useState({
    currentCPU: '',
    currentGPU: '',
    currentRAM: '',
    useCase: 'gaming'
  });
  
  const [nasFormData, setNasFormData] = useState({
    diskCount: '2',
    raidType: 'raid1',
    storageNeeds: ''
  });
  
  const [serverFormData, setServerFormData] = useState({
    serverType: 'web',
    ramNeeds: '',
    cpuCores: ''
  });
  
  const [cameraFormData, setCameraFormData] = useState({
    cameraType: 'dslr',
    primaryUse: 'photography'
  });

  // Reset recommendations when device type changes
  useEffect(() => {
    setShowRecommendations(false);
    setUpgradeBudget('');
  }, [deviceType]);

  // Mock recommendations data
  const getRecommendations = () => {
    // Create mock listing IDs that match the recommendations
    const mockListingIds = {
      pc: ['rtx4070', 'list002'],
      nas: [],
      server: [],
      camera: []
    };

    const recommendationsByDevice = {
      pc: [
        {
          id: 1,
          listingId: mockListingIds.pc[0],
          title: 'NVIDIA RTX 4070',
          description: 'Perfect for gaming and content creation with ray tracing and DLSS technology.',
          price: 'HK$5,999',
          image: 'https://images.unsplash.com/photo-1591488320449-011701bb6704?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
        },
        {
          id: 2,
          listingId: mockListingIds.pc[1],
          title: 'AMD Ryzen 7 5800X',
          description: 'High-performance 8-core processor ideal for gaming and multitasking.',
          price: 'HK$3,499',
          image: 'https://images.unsplash.com/photo-1591799264318-7e6ef8ddb7ea?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
        }
      ],
      nas: [
        {
          id: 1,
          title: 'NAS Recommendations',
          description: 'NAS upgrade recommendations are not available at this time.',
          price: '',
          image: 'https://images.unsplash.com/photo-1586944179719-0d49a3948f6e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
          unavailable: true
        }
      ],
      server: [
        {
          id: 1,
          title: 'Server Recommendations',
          description: 'Server upgrade recommendations are not available at this time.',
          price: '',
          image: 'https://images.unsplash.com/photo-1573164574572-cb89e39749b4?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
          unavailable: true
        }
      ],
      camera: [
        {
          id: 1,
          title: 'Camera Recommendations',
          description: 'Camera upgrade recommendations are not available at this time.',
          price: '',
          image: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
          unavailable: true
        }
      ]
    };
    
    return recommendationsByDevice[deviceType] || recommendationsByDevice.pc;
  };

  const handleDeviceTypeChange = (type) => {
    setDeviceType(type);
  };

  const handlePcFormChange = (e) => {
    setPcFormData({
      ...pcFormData,
      [e.target.name]: e.target.value
    });
  };

  const handleNasFormChange = (e) => {
    setNasFormData({
      ...nasFormData,
      [e.target.name]: e.target.value
    });
  };

  const handleServerFormChange = (e) => {
    setServerFormData({
      ...serverFormData,
      [e.target.name]: e.target.value
    });
  };

  const handleCameraFormChange = (e) => {
    setCameraFormData({
      ...cameraFormData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate budget
    if (!upgradeBudget || isNaN(parseInt(upgradeBudget)) || parseInt(upgradeBudget) <= 0) {
      alert('Please enter a valid budget');
      return;
    }
    
    // Get recommendations and show them
    setRecommendations(getRecommendations());
    setShowRecommendations(true);
    
    // Scroll to recommendations
    setTimeout(() => {
      const recommendationsSection = document.getElementById('recommendations');
      if (recommendationsSection) {
        recommendationsSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleCreateWtbPost = () => {
    // Default values based on current form data
    let itemTitle = '';
    let itemDescription = '';
    let category = 'Computer Parts';
    
    // Set appropriate default title based on device type
    switch(deviceType) {
      case 'pc':
        itemTitle = pcFormData.currentCPU ? `WTB: Upgrade for ${pcFormData.currentCPU}` : 'WTB: PC Component';
        itemDescription = `I'm looking to upgrade my current setup: ${pcFormData.currentCPU || 'CPU'}, ${pcFormData.currentGPU || 'GPU'}, ${pcFormData.currentRAM || 'RAM'} for ${pcFormData.useCase || 'general use'}.`;
        category = 'Computer Parts';
        break;
      case 'nas':
        itemTitle = 'WTB: NAS System or Components';
        itemDescription = `Looking for NAS with ${nasFormData.diskCount} bays, ${nasFormData.raidType} capability, and ${nasFormData.storageNeeds || 'sufficient'} storage.`;
        category = 'Computer Parts';
        break;
      case 'server':
        itemTitle = 'WTB: Server Components';
        itemDescription = `Seeking ${serverFormData.serverType} server components with ${serverFormData.ramNeeds || 'sufficient'} RAM and ${serverFormData.cpuCores || 'adequate'} CPU cores.`;
        category = 'Computer Parts';
        break;
      case 'camera':
        itemTitle = `WTB: ${cameraFormData.cameraType.toUpperCase()} Camera Equipment`;
        itemDescription = `Looking for camera equipment for ${cameraFormData.primaryUse}.`;
        category = 'Cameras';
        break;
      default:
        itemTitle = 'WTB: Tech Equipment';
        itemDescription = 'Looking for specific tech equipment not currently available.';
        category = 'Electronics';
    }
    
    // Create URL with parameters
    const params = new URLSearchParams();
    params.append('type', 'wtb');
    params.append('title', encodeURIComponent(itemTitle));
    params.append('description', encodeURIComponent(itemDescription));
    params.append('category', encodeURIComponent(category));
    params.append('condition', encodeURIComponent('Fully Working'));
    params.append('minPrice', '0');
    params.append('maxPrice', upgradeBudget || '5000');
    
    // Navigate to create listing page with parameters
    window.location.href = `/create-listing?${params.toString()}`;
  };

  const renderDeviceForm = () => {
    switch(deviceType) {
      case 'pc':
        return (
          <>
            <div className="form-group">
              <label htmlFor="currentCPU">Current CPU</label>
              <input
                type="text"
                id="currentCPU"
                name="currentCPU"
                className="form-control"
                placeholder="e.g., Intel i5-10400"
                value={pcFormData.currentCPU}
                onChange={handlePcFormChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="currentGPU">Current GPU</label>
              <input
                type="text"
                id="currentGPU"
                name="currentGPU"
                className="form-control"
                placeholder="e.g., NVIDIA GTX 1660"
                value={pcFormData.currentGPU}
                onChange={handlePcFormChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="currentRAM">Current RAM</label>
              <input
                type="text"
                id="currentRAM"
                name="currentRAM"
                className="form-control"
                placeholder="e.g., 16GB DDR4"
                value={pcFormData.currentRAM}
                onChange={handlePcFormChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="useCase">Primary Use Case</label>
              <select
                id="useCase"
                name="useCase"
                className="form-control"
                value={pcFormData.useCase}
                onChange={handlePcFormChange}
              >
                <option value="gaming">Gaming</option>
                <option value="video-editing">Video Editing</option>
                <option value="development">Software Development</option>
                <option value="office">Office Work</option>
              </select>
            </div>
          </>
        );
      case 'nas':
        return (
          <>
            <div className="form-group">
              <label htmlFor="diskCount">Number of Disk Bays</label>
              <select
                id="diskCount"
                name="diskCount"
                className="form-control"
                value={nasFormData.diskCount}
                onChange={handleNasFormChange}
              >
                <option value="2">2-Bay</option>
                <option value="4">4-Bay</option>
                <option value="6">6-Bay</option>
                <option value="8+">8+ Bay</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="raidType">Preferred RAID Type</label>
              <select
                id="raidType"
                name="raidType"
                className="form-control"
                value={nasFormData.raidType}
                onChange={handleNasFormChange}
              >
                <option value="raid0">RAID 0 (Striping)</option>
                <option value="raid1">RAID 1 (Mirroring)</option>
                <option value="raid5">RAID 5 (Single Parity)</option>
                <option value="raid10">RAID 10 (Mirrored Stripes)</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="storageNeeds">Storage Needs (TB)</label>
              <input
                type="text"
                id="storageNeeds"
                name="storageNeeds"
                className="form-control"
                placeholder="e.g., 8"
                value={nasFormData.storageNeeds}
                onChange={handleNasFormChange}
              />
            </div>
          </>
        );
      case 'server':
        return (
          <>
            <div className="form-group">
              <label htmlFor="serverType">Server Type</label>
              <select
                id="serverType"
                name="serverType"
                className="form-control"
                value={serverFormData.serverType}
                onChange={handleServerFormChange}
              >
                <option value="web">Web Server</option>
                <option value="database">Database Server</option>
                <option value="application">Application Server</option>
                <option value="virtualization">Virtualization Host</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="ramNeeds">RAM Requirements (GB)</label>
              <input
                type="text"
                id="ramNeeds"
                name="ramNeeds"
                className="form-control"
                placeholder="e.g., 32"
                value={serverFormData.ramNeeds}
                onChange={handleServerFormChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="cpuCores">CPU Cores Needed</label>
              <input
                type="text"
                id="cpuCores"
                name="cpuCores"
                className="form-control"
                placeholder="e.g., 8"
                value={serverFormData.cpuCores}
                onChange={handleServerFormChange}
              />
            </div>
          </>
        );
      case 'camera':
        return (
          <>
            <div className="form-group">
              <label htmlFor="cameraType">Camera Type</label>
              <select
                id="cameraType"
                name="cameraType"
                className="form-control"
                value={cameraFormData.cameraType}
                onChange={handleCameraFormChange}
              >
                <option value="dslr">DSLR</option>
                <option value="mirrorless">Mirrorless</option>
                <option value="compact">Compact</option>
                <option value="action">Action Camera</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="primaryUse">Primary Use</label>
              <select
                id="primaryUse"
                name="primaryUse"
                className="form-control"
                value={cameraFormData.primaryUse}
                onChange={handleCameraFormChange}
              >
                <option value="photography">Photography</option>
                <option value="videography">Videography</option>
                <option value="hybrid">Hybrid (Photo/Video)</option>
                <option value="streaming">Live Streaming</option>
              </select>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="ai-advisor-page">
      <div className="advisor-header">
        <h1>Tech Upgrade Advisor</h1>
        <p>Get personalized recommendations for your next technology upgrade based on your needs and budget.</p>
      </div>
      
      <div className="advisor-container">
        <div className="advisor-form-container">
          <h2>Tell us about your needs</h2>
          
          <form onSubmit={handleSubmit}>
            <div className="device-type-selector">
              <div className={`device-option ${deviceType === 'pc' ? 'active' : ''}`}>
                <button 
                  type="button" 
                  className="device-button"
                  onClick={() => handleDeviceTypeChange('pc')}
                >
                  <FaDesktop className="device-icon" />
                  <span className="device-label">PC / Laptop</span>
                </button>
              </div>
              
              <div className={`device-option ${deviceType === 'nas' ? 'active' : ''}`}>
                <button 
                  type="button" 
                  className="device-button"
                  onClick={() => handleDeviceTypeChange('nas')}
                >
                  <FaHdd className="device-icon" />
                  <span className="device-label">NAS</span>
                </button>
              </div>
              
              <div className={`device-option ${deviceType === 'server' ? 'active' : ''}`}>
                <button 
                  type="button" 
                  className="device-button"
                  onClick={() => handleDeviceTypeChange('server')}
                >
                  <FaServer className="device-icon" />
                  <span className="device-label">Server</span>
                </button>
              </div>
              
              <div className={`device-option ${deviceType === 'camera' ? 'active' : ''}`}>
                <button 
                  type="button" 
                  className="device-button"
                  onClick={() => handleDeviceTypeChange('camera')}
                >
                  <FaCamera className="device-icon" />
                  <span className="device-label">Camera</span>
                </button>
              </div>
            </div>
            
            {renderDeviceForm()}
            
            <div className="form-group">
              <label htmlFor="upgradeBudget">Upgrade Budget (USD)</label>
              <input
                type="text"
                id="upgradeBudget"
                className="form-control"
                placeholder="e.g., 500"
                value={upgradeBudget}
                onChange={(e) => setUpgradeBudget(e.target.value)}
                required
              />
            </div>
            
            <button type="submit" className="get-recommendations-button">
              Get Recommendations
            </button>
          </form>
        </div>
        
        {showRecommendations && (
          <div id="recommendations" className="recommendations-container">
            <div className="recommendations-header">
              <h2>Your Personalized Recommendations</h2>
              <p>Based on your {deviceType.toUpperCase()} configuration and budget of ${upgradeBudget}</p>
            </div>
            
            <div className="recommendations-grid">
              {recommendations.map(item => (
                <div key={item.id} className="recommendation-card">
                  {item.unavailable ? (
                    <div className="recommendation-content not-available">
                      <div className="not-available-message">
                        <h3 className="recommendation-title">{item.title}</h3>
                        <p className="recommendation-description">{item.description}</p>
                      </div>
                    </div>
                  ) : item.title === 'AMD Ryzen 7 5800X' ? (
                    <div className="recommendation-content not-available">
                      <div className="recommendation-image">
                        <img src={item.image} alt={item.title} />
                        <div className="not-available-overlay">Currently Unavailable</div>
                      </div>
                      <h3 className="recommendation-title">{item.title}</h3>
                      <p className="recommendation-description">{item.description}</p>
                      <p className="recommendation-price">{item.price}</p>
                      <p className="not-available-message">This item is currently not available on the platform</p>
                      <button 
                        className="create-wtb-button"
                        onClick={() => {
                          // Create URL with parameters for AMD Ryzen 7 5800X
                          const params = new URLSearchParams();
                          params.append('type', 'wtb');
                          params.append('title', encodeURIComponent("AMD Ryzen 7 5800X CPU"));
                          params.append('description', encodeURIComponent(
                            "Looking for a new or lightly used AMD Ryzen 7 5800X CPU. " +
                            "8-core/16-thread, AM4 socket, 3.8GHz base clock, 4.7GHz boost. " +
                            "Compatible with 500 series motherboards. " +
                            "Please contact me if you have one available."
                          ));
                          params.append('category', encodeURIComponent('Computer Parts'));
                          params.append('condition', encodeURIComponent('Fully Working'));
                          params.append('minPrice', '0');
                          params.append('maxPrice', upgradeBudget || '3500');
                          
                          // Navigate to create listing page with parameters
                          window.location.href = `/create-listing?${params.toString()}`;
                        }}
                      >
                        Create WTB Post for This CPU
                      </button>
                    </div>
                  ) : (
                    <Link to={`/listing/${item.listingId}`} className="recommendation-link">
                      <div className="recommendation-image">
                        <img src={item.image} alt={item.title} />
                      </div>
                      <div className="recommendation-content">
                        <h3 className="recommendation-title">{item.title}</h3>
                        <p className="recommendation-description">{item.description}</p>
                        <p className="recommendation-price">{item.price}</p>
                        <span className="view-listing-button">View Listing</span>
                      </div>
                    </Link>
                  )}
                </div>
              ))}
            </div>
            
            <div className="wtb-section">
              <h3>Can't find what you're looking for?</h3>
              <p>Create a "Want to Buy" post to let the community know what you're looking for.</p>
              <button 
                className="create-wtb-button"
                onClick={() => handleCreateWtbPost()}
              >
                Create WTB Post
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AiAdvisorPage; 